:root ._dsp-flex{display:flex;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._justify-center{justify-content:center;}
:root ._items-center{align-items:center;}
:root ._items-stretch{align-items:stretch;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._btw-1px{border-top-width:1px;}
:root ._bg-backgroundB3327275{background-color:var(--backgroundBlock);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._maxW-600px{max-width:600px;}
:root ._width-10037{width:100%;}
:root ._borderTopStyle-solid{border-top-style:solid;}